import { FormikProps } from 'formik'

export interface IFormInputConfig {
  formKey: string
  placeholder?: string
  type: TValidInputTypes
  dependency?: Array<IDependency> | null
  label: string
  desc?: string
  styles?: OptionalRecord
  styling?: {
    styles?: OptionalRecord
    variant?: any
    className?: string
  }
  row?: number
  options: IFormRowConfig | boolean | { [key: string]: any }[] | null
  isMulti?: boolean
  multiSelectLimit?: number
  error?: string
  validation: TValidation | null
  regex?: string
  apiUrl?: string
  searchQueryKey?: string
  configQuery?: string
  apiResultKey?: string
  labelForDisplay?: string
  valueForDisplay?: string
  unit?: string
  creatableType?: 'number' | 'string'
  value?: any
  isHidden?: boolean
  disabled?: boolean
}

export interface IFormConfig {
  label: string
  formKey: string
  desc: string
  hideSubmitButtonTimer?: number
  formConfig: IFormRowConfig
  styles?: OptionalRecord
  options?: any
  btnConfig?: {
    submitButton: IFormButtonConfig
    resetButton: IFormButtonConfig
  }
  disableSubmit?: boolean
  setDisableSubmit?: (val: any) => void
}

export interface IFormButtonConfig {
  label: string
  style: React.CSSProperties
  isDisplay: boolean
}
export interface IDependency {
  key: string
  type: string
  value: any
  format: any
}
export interface IFormRowConfig {
  [key: string]: IFormRowElement
}

export interface IFormRowElement {
  style: any
  data: IFormInputConfig[]
}
export interface ICustomFormField extends FormikProps<any> {
  config: IFormInputConfig
  style?: React.CSSProperties
  formikProps: FormikProps<any>
}

export interface IComponentFormField extends ICustomFormField {
  formKeyName: string
  count: number
  baseUrl: string
  position: number
  showTimezone?: boolean
}

export const CSelect = ['select', 'async', 'creatable', 'local-select', 'poi-async-select']
export const CDate = ['date', 'date-range', 'time']
export const CInput = ['text', 'number', 'email', 'textarea', 'password']
export const CConditional = ['radio', 'checkbox']
export const CMultiAdd = ['multi-add']

type TSelect = 'select' | 'async' | 'creatable' | 'local-select' | 'poi-async-select'
type TDate = 'date' | 'date-range' | 'time'
type TInput = 'text' | 'number' | 'email' | 'textarea'
type TConditional = 'radio' | 'checkbox'
type TMultiAdd = 'multi-add'
type TValidInputTypes = TInput | TSelect | TDate | TConditional | TMultiAdd | 'heading'

type TValidation = 'required' | 'email' | 'phone' | 'password' | 'regex' | 'url'

export type OptionalRecord = {
  label?: React.CSSProperties
  container?: React.CSSProperties
  errorText?: React.CSSProperties
  desc?: React.CSSProperties
  inputType?: React.CSSProperties
  inputContainer?: React.CSSProperties
}
export interface IFormBuilderState {
  formState: any
  validationSchema: {}
  rowColumnConfig: Record<string, IFormRowElement>
}
